import { GeometryUtils } from '../thirdparty/three/imports';

export class GeometryUtils3D
{
    static gosper(size?: number)
    {
        return GeometryUtils.gosper(size);
    }
}
